// This device's nickname (set in Settings), stamped on the doses and
// temperature readings it logs.
export const getDeviceName = () => {
  try { return localStorage.getItem('medDeviceName') || ''; } catch { return ''; }
};
